import AppIcon from '@shelflix/ui-web/components/AppIcon';
import React from 'react';
import shortcutSvg from '@/assets/icons-normalized/shortcut.svg?raw';
import calendarSvg from '@/assets/icons-normalized/calendar.svg?raw';
import plusSvg from '@/assets/icons-normalized/plus.svg?raw';
import usersSvg from '@/assets/icons-normalized/users.svg?raw';
import { useNavigate } from 'react-router-dom';
import { DashboardCard } from '../DashboardCard';
import { cn } from '@/utils/utils';

export function ShortcutCard({ className }: { className?: string }) {
  const navigate = useNavigate();

  return (
    <DashboardCard title="Atalhos" icon={shortcutSvg} className={cn('bg-[#191919CC]', className)}>
      <div className="grid w-full gap-3">
        <div
          className="flex cursor-pointer flex-col rounded-[5px] border border-[#332F2B] bg-[#0E0E0E] px-4 py-2"
          onClick={() => navigate('/pos')}
        >
          <div className="grid grid-cols-[auto_1fr] items-center gap-2 text-[#E57300]">
            <AppIcon
              source="svg"
              name="monitor-online"
              svgContent={calendarSvg}
              size={24}
              weight={400}
              className="p-1"
            />
            <h4 className="text-base font-normal">Agendar Campanha</h4>
          </div>
          <p className="text-xs text-[#FFF9F2]">
            Vá a um estabelecimento e selecione uma campanha a partir da biblioteca disponível
          </p>
        </div>
        <div
          className="flex cursor-pointer flex-col rounded-[5px] border border-[#332F2B] bg-[#0E0E0E] px-4 py-2"
          onClick={() => navigate('/pos/create')}
        >
          <div className="grid grid-cols-[auto_1fr] items-center gap-2 text-[#E57300]">
            <AppIcon source="svg" name="monitor-online" svgContent={plusSvg} size={24} weight={400} className="p-1" />
            <h4 className="text-base font-normal">Cadastrar novo material</h4>
          </div>
          <p className="text-xs text-[#FFF9F2]">Inserir uma nova tela no sistema com Material de PDV</p>
        </div>
        <div
          className="flex cursor-pointer flex-col rounded-[5px] border border-[#332F2B] bg-[#0E0E0E] px-4 py-2"
          onClick={() => navigate('/campaign/create')}
        >
          <div className="grid grid-cols-[auto_1fr] items-center gap-2 text-[#E57300]">
            <AppIcon source="svg" name="monitor-online" svgContent={usersSvg} size={24} weight={400} className="p-1" />
            <h4 className="text-base font-normal">Criar Campanha</h4>
          </div>
          <p className="text-xs text-[#FFF9F2]">
            Leva ao editor de campanhas para selecionar mídias e agendar data de disponibilidade
          </p>
        </div>
      </div>
    </DashboardCard>
  );
}
